var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative bg-yellow-300 md:pt-32 pb-16 pt-12"},[_c('div',{staticClass:"px-4 md:px-10 mx-auto w-full"},[_c('div')])])}]

export { render, staticRenderFns }